export class AppSettings {
  public static DEFAULT_ERROR = 'Une erreur innatendue est survenue';
}
